export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 9_03.d6fcbedb.jpg";